import { render, staticRenderFns } from "./VideoOff.vue?vue&type=template&id=53c70838"
import script from "./VideoOff.vue?vue&type=script&lang=js"
export * from "./VideoOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports